import React, {useEffect, useMemo} from 'react';
import {useSavedCartForm} from '../../hooks';
import {type ISavedCart, type ISavedCartFormValues} from '../../schema';
import {
	SavedCartManagerDialog,
	type SavedCartManagerDialogProps,
} from './SavedCartManagerDialog';

export interface SavedCartManagerDialogContainerProps
	extends Omit<
		SavedCartManagerDialogProps,
		'form' | 'users' | 'onUserAdd' | 'onUserRemove' | 'onSubmit'
	> {
	savedCart: ISavedCart;
	onSubmit: (data: ISavedCartFormValues) => Promise<void>;
}

/**
 * `SavedCartManagerDialogContainer` is a container component that provides context and submission logic for the `SavedCartManagerDialog`.
 */

export const SavedCartManagerDialogContainer = ({
	savedCart,
	onSubmit: _onSubmit,
	...props
}: SavedCartManagerDialogContainerProps) => {
	const initialValues = useMemo(
		() => ({
			title: savedCart.title,
			id: savedCart.id,
		}),
		[savedCart],
	);

	const {form, reset, onSubmit} = useSavedCartForm({
		initialValues,
		submit: _onSubmit,
	});

	useEffect(() => {
		reset({
			title: savedCart.title,
			id: savedCart.id,
		});
	}, [savedCart]);

	return <SavedCartManagerDialog form={form} onSubmit={onSubmit} {...props} />;
};
